module.exports = __webpack_public_path__ + "img/15-small.ba9e1a71.png";